// RecentList.js
// "Recent" section: the last few activity-feed items with a relative time.
// See docs/superpowers/specs/2026-09-16-home-redesign.md §5 (Student > RecentList).
import React from "react";

import HomeSection from "../primitives/HomeSection";
import HomeCard from "../primitives/HomeCard";
import HomeRow from "../primitives/HomeRow";
import { relativeDay } from "../homeTime";

const TYPE_ICONS = {
  pwo: "cube-outline",
  video: "play-circle-outline",
  chat: "message-text-outline",
  prompt: "lightbulb-outline",
};

const RecentList = ({ activities = [], onActivityPress, isDarkMode = false, t = (s) => s }) => {
  if (!Array.isArray(activities) || activities.length === 0) return null;

  const now = new Date();

  return (
    <HomeSection title={t("Recent")} isDarkMode={isDarkMode}>
      <HomeCard isDarkMode={isDarkMode} testID="recent-list">
        {activities.map((activity, index) => (
          <HomeRow
            key={activity.id ?? index}
            first={index === 0}
            icon={TYPE_ICONS[activity.type] || null}
            title={activity.title}
            subtitle={relativeDay(activity.timestamp, now, t)}
            onPress={() => onActivityPress?.(activity)}
            isDarkMode={isDarkMode}
            testID={`recent-row-${activity.id ?? index}`}
          />
        ))}
      </HomeCard>
    </HomeSection>
  );
};

export default RecentList;
